export default class FilterValue {
    public tagIds: string[] = new Array<string>();
    public searchText: string = '';
}
